import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#A3A3A3]" data-testid="auth-loading">
        <div className="font-display text-2xl tracking-widest uppercase">Loading…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (role && user.role !== role) {
    // redirect to proper home
    const dest = user.role === "coach" ? "/coach" : user.role === "student" ? "/student" : user.role === "admin" ? "/admin" : "/";
    return <Navigate to={dest} replace />;
  }
  return children;
}
